import $ from 'jquery';

var opensDrilldown = $('[data-toggle="header-megamenu-drilldown"]');

$('#header-megamenu-drilldown').on('closed.zf.drilldown', function () {
    opensDrilldown.focus();
});
